import React, { useState } from "react";
import { motion, AnimatePresence } from "framer-motion";
import "../../../programs.css";
import sampleImage from "../../../Image/faq.jpg";

const newsData = [
  {
    title: "Which programming languages are important in Bioinformatics?",
    category: "Technology",
    description:
      "Python and R are the most important languages due to their strong data analysis libraries. Perl, Java, and C++ are also used in specialized tools, pipelines, and large-scale biological computations.",
  },
  {
    title: "What tools are commonly used in Bioinformatics?",
    category: "Trending",
    description:
      "Bioinformatics uses tools like BLAST, FASTA, Bioconductor, Galaxy, PyMOL, Clustal Omega, and Linux command-line utilities. These tools help analyze sequences, visualize proteins, align genomes, and perform complex biological computations.",
  },
  {
    title: "What industries hire Bioinformatics professionals?",
    category: "Design",
    description:
      "Bioinformatics experts are in demand in pharmaceuticals, biotechnology, healthcare, genomics, agriculture, research labs, diagnostic companies, and personalized medicine programs. These industries rely heavily on biological data for innovation and development.",
  },
  {
    title: "What kind of projects do students work on in Bioinformatics?",
    category: "Design",
    description:
      "Students work on genome analysis, protein structure prediction, sequence alignment, mutation studies, drug discovery pipelines, gene expression analysis, and biological database development to gain practical, research-oriented experience.",
  },
  {
    title: "Is Bioinformatics coding-heavy?",
    category: "Design",
    description:
      "Bioinformatics requires moderate coding skills, especially for data analysis, automation, and pipeline creation. While biology knowledge is useful, programming and data manipulation form the core of most Bioinformatics tasks.",
  },
];

const FAQ = () => {
  const [expandedIndex, setExpandedIndex] = useState(null);

  const toggleDescription = (i) => {
    setExpandedIndex(expandedIndex === i ? null : i);
  };

  return (
    <div className="faq-wrapper">
      <motion.h2
        className="faq-heading"
        initial={{ opacity: 0, y: -20 }}
        whileInView={{ opacity: 1, y: 0 }}
        transition={{ duration: 0.6 }}
      >
        FAQ — Frequently Asked Questions
      </motion.h2>
      <div className="news-section-container">
        <motion.div
          className="news-left-image"
          initial={{ opacity: 0, rotateY: -90 }}
          whileInView={{ opacity: 1, rotateY: 0 }}
          transition={{
            duration: 0.9,
            ease: "easeOut",
            delay: 0.2,
          }}
          viewport={{ once: false, amount: 0.4 }}
        >
          <img src={sampleImage} alt="Main Preview" />
        </motion.div>

        <motion.div
          className="news-right-list"
          initial={{ opacity: 0, scale: 0.8, y: 40 }}
          whileInView={{ opacity: 1, scale: 1, y: 0 }}
          transition={{
            duration: 0.8,
            ease: "easeOut",
            delay: 0.3,
          }}
          viewport={{ once: false, amount: 0.3 }}
        >
          {newsData.map((item, index) => (
            <motion.div
              key={index}
              className="news-item"
              whileHover={{ x: 10, backgroundColor: "#eefef6" }}
              transition={{ duration: 0.3 }}
              onClick={() => toggleDescription(index)}
            >
              <div className="row">
                <div className="title">{item.title}</div>

                {/* <div className="category">{item.category}</div> */}

                <motion.div
                  animate={{ rotate: expandedIndex === index ? 90 : 0 }}
                  transition={{ duration: 0.3 }}
                  className="arrow"
                >
                  ➤
                </motion.div>
              </div>

              <AnimatePresence>
                {expandedIndex === index && (
                  <motion.div
                    className="card-description"
                    layout
                    initial={{ opacity: 0, maxHeight: 0 }}
                    animate={{ opacity: 1, maxHeight: 800 }}
                    exit={{ opacity: 0, maxHeight: 0 }}
                    transition={{
                      duration: 0.45,
                      ease: "easeInOut",
                    }}
                  >
                    {item.description}
                  </motion.div>
                )}
              </AnimatePresence>
            </motion.div>
          ))}
        </motion.div>
      </div>
    </div>
  );
};

export default FAQ;
